import { Routes } from '@angular/router';
export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./components/app-bar/app-bar.routes').then((m) => m.routes),
    },
];
